import { createSelector, createStructuredSelector } from 'reselect';
import { initialState } from './reducer';
import { LMS_NAMESPACE } from 'Container/App/constants';
import { RootState } from 'Container/App/types';
import { selectActiveOverlay, selectIsOverlayOpen } from 'Container/App/selector';

const selectState = (state: RootState) => state[LMS_NAMESPACE] || initialState;

export const selectLmsState = createSelector(selectState, state => state);
export const selectLmsError = createSelector(selectState, state => state.lmsError);
export const selectLmsFormData = createSelector(selectState, state => state.formData);
export const selectLmsResponseData = createSelector(selectState, state => state.responseData);
export const selectOpenedBy = createSelector(selectState, state => state.openedBy);

export const selectors = createStructuredSelector({
    lmsError: selectLmsError,
    formData: selectLmsFormData,
    responseData: selectLmsResponseData,
    openedBy: selectOpenedBy,
    activeOverlay: selectActiveOverlay,
    isOverlayOpen: selectIsOverlayOpen,
});
